import { useRecently } from 'platform-lib-app';

// 基本类型
export const RECENTTYPE = {
  INFO: 'info',
  ANNOUNCE: 'announce',
  TASK: 'task',
  NOTICE: 'notice',
  FINANCIAL: 'financial',
  PACKINGLIST: 'packingList',
  DIFFPACKINGLIST: 'diffPackingList',
  STOCKIN: 'stockIn',
  STOCKOUT: 'stockOut',
  FLOW: 'flow',
  STOCKCHECK: 'stockCheck',
  BANK: 'bank', // 开户行
  BRANCH: 'branch', // 开户支行
  iNVENTORYLIST: 'inventoryList', // 盘点单列表
  MATERIALNAME_LIST: 'materialNameList', // 订货管理 订单号
  iNVENTORYDETAIL: 'inventoryDetail', // 盘点单详情
  CONFIRMCOMPLET: 'confirmCompletionInventory', // 盘点完成
  SELECTGOOD: 'selectGood', // 选择货物
  INVENTORYDETAL: 'inventoryDetail', // 编辑盘点单
  EMPLOYEE: 'employeeList', //员工列表
  GOODSLIST: 'goodsList', //商品列表
};

const recently = useRecently();

// 获取最近搜索列表
export function getRecentlyList(type) {
  return recently.getRecentlyList(type);
};

// 设置最近搜索
export function setRecentlyList(type, searchName) {
  return recently.setRecentlyList(type, searchName);
}

// 清空最近搜索列表
export function clearRecentlyList() {
  return recently.clearRecentlyList();
}